<template>
  <div class="expandable-height-container">
    <PartnerStatsView v-if="partnerId" :startDate="startDate" :endDate="endDate" :partnerId="partnerId" />
  </div>
</template>

<script>
import moment from 'moment';
import PartnerStatsView from '../Dashboards/Components/PartnerStatsView';

export default {
  name: 'PartnerStats',
  components: {
    PartnerStatsView
  },
  props: ['partnerId'],
  data() {
    return {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment()
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    };
  }
};
</script>

<style scoped>
.expandable-height-container {
  height: calc(100vh - 130px);
  max-height: calc(100vh - 130px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
